import RewardTriggerEnum from '../../../../../Spirit/Entities/Enums/RewardTriggerEnum';

export default class RewardTriggerResponse  {
	Trigger: RewardTriggerEnum = null;
	Name?: string = '';
	constructor(obj?: Partial<RewardTriggerResponse>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
